import React, { useState } from 'react';
import { FaTimes, FaChevronDown, FaChevronRight, FaSearch } from 'react-icons/fa';

function FiltersDropdown({ onClose, filters, onFilterChange }) {
  // State for nested options visibility (Media Type, Countries/Regions, Demographics)
  const [openCategory, setOpenCategory] = useState(null);
  // State for search inputs within dropdown sections
  const [searchTextFilter, setSearchTextFilter] = useState('');
  const [searchMediaType, setSearchMediaType] = useState('');
  const [searchCountries, setSearchCountries] = useState('');
  const [searchDemographics, setSearchDemographics] = useState('');

  const handleCategoryClick = (categoryKey) => {
    setOpenCategory(openCategory === categoryKey ? null : categoryKey);
    // Optionally clear search term when changing category
    if (openCategory !== categoryKey) {
        setSearchMediaType('');
        setSearchCountries('');
        setSearchDemographics('');
    }
  };

  const handleCheckboxChange = (category, value) => {
    const currentFilters = filters[category] || [];
    const newFilters = currentFilters.includes(value)
      ? currentFilters.filter(item => item !== value)
      : [...currentFilters, value];
    onFilterChange({ ...filters, [category]: newFilters });
  };

  const handleSentimentChange = (sentimentValue) => {
    const currentSentimentFilters = filters.sentiment || [];
    const newSentimentFilters = currentSentimentFilters.includes(sentimentValue)
      ? currentSentimentFilters.filter(item => item !== sentimentValue)
      : [...currentSentimentFilters, sentimentValue];
    onFilterChange({ ...filters, sentiment: newSentimentFilters });
  };

  const handleTextFilterChange = (e) => {
      setSearchTextFilter(e.target.value);
      // You might want to debounce this for actual filtering
      // onFilterChange({ ...filters, textQuery: e.target.value });
  };

  return (
    <div className="filters-dropdown">
      <div className="dropdown-header">
        <h3>Search, All Filter</h3> {/* Title based on screenshot */}
        <FaTimes className="close-icon" onClick={onClose} style={{ cursor: 'pointer' }}/>
      </div>

      <div className="dropdown-content">

        {/* Text Filter */}
        <div className="filter-section">
          <div className="section-header">
            <h4>TEXT FILTER</h4>
             <FaChevronDown /> {/* Collapse/Expand icon */}
          </div>
           <div className="section-content">
              <input
                type="text"
                placeholder="Type in your Filter Query here"
                value={searchTextFilter}
                onChange={handleTextFilterChange}
                className="text-filter-input"
              />
               {/* Add second input if needed based on screenshot details */}
              <input
                type="text"
                placeholder="Type in your Filter Query here"
                value={searchTextFilter}
                onChange={handleTextFilterChange}
                className="text-filter-input"
              />
           </div>
        </div>

        {/* Sentiment */}
        <div className="filter-section">
          <div className="section-header">
            <h4>SENTIMENT</h4>
             <FaChevronDown /> {/* Collapse/Expand icon */}
          </div>
          <div className="section-content">
             <label>
               <input
                 type="checkbox"
                 checked={filters.sentiment?.includes('positive') || false}
                 onChange={() => handleSentimentChange('positive')}
               /> Positive
             </label>
              <label>
               <input
                 type="checkbox"
                 checked={filters.sentiment?.includes('neutral') || false}
                 onChange={() => handleSentimentChange('neutral')}
               /> Neutral
             </label>
              <label>
               <input
                 type="checkbox"
                 checked={filters.sentiment?.includes('negative') || false}
                 onChange={() => handleSentimentChange('negative')}
               /> Negative
             </label>
              <label>
               <input
                 type="checkbox"
                 checked={filters.sentiment?.includes('important') || false} // Assuming 'Important' maps to a sentiment or flag
                 onChange={() => handleSentimentChange('important')}
               /> Important!
             </label>
          </div>
        </div>

        {/* Media Type */}
        <div className={`filter-section ${openCategory === 'mediaType' ? 'open' : ''}`}>
          <div className="section-header" onClick={() => handleCategoryClick('mediaType')}> {/* Clickable header */}
            <h4>Media Type</h4>
            <span>{filters.mediaType?.length > 0 ? filters.mediaType.join(', ') : 'No Active Media Type'}</span>
             <FaChevronRight className="chevron-icon"/>
          </div>
           {openCategory === 'mediaType' && (
             <div className="section-content nested">
                <div className="search-input-container">
                   <FaSearch />
                   <input
                     type="text"
                     placeholder="Search Media Type"
                     value={searchMediaType}
                     onChange={(e) => setSearchMediaType(e.target.value)}
                   />
                </div>
                 {/* Static list for now, would be dynamic based on data */}
                <label>
                  <input
                    type="checkbox"
                    checked={filters.mediaType?.includes('All Media Type') || false}
                    onChange={() => handleCheckboxChange('mediaType', 'All Media Type')}
                  /> All Media Type
                </label>
                <label>
                  <input
                    type="checkbox"
                     checked={filters.mediaType?.includes('Actun') || false}
                    onChange={() => handleCheckboxChange('mediaType', 'Actun')}
                  /> Actun
                </label>
                <label>
                  <input
                    type="checkbox"
                    checked={filters.mediaType?.includes('Blogs') || false}
                    onChange={() => handleCheckboxChange('mediaType', 'Blogs')}
                  /> Blogs
                </label>
                 <label>
                  <input
                    type="checkbox"
                    checked={filters.mediaType?.includes('External') || false}
                    onChange={() => handleCheckboxChange('mediaType', 'External')}
                  /> External
                </label>
                 <label>
                  <input
                    type="checkbox"
                    checked={filters.mediaType?.includes('Facebook') || false}
                    onChange={() => handleCheckboxChange('mediaType', 'Facebook')}
                  /> Facebook
                </label>
                 <label>
                  <input
                    type="checkbox"
                    checked={filters.mediaType?.includes('Youtube') || false}
                    onChange={() => handleCheckboxChange('mediaType', 'Youtube')}
                  /> Youtube
                </label>
                 <label>
                  <input
                    type="checkbox"
                    checked={filters.mediaType?.includes('Twitter') || false}
                    onChange={() => handleCheckboxChange('mediaType', 'Twitter')}
                  /> Twitter
                </label>
             </div>
           )}
        </div>

        {/* Countries/Regions */}
         <div className={`filter-section ${openCategory === 'countries' ? 'open' : ''}`}>
          <div className="section-header" onClick={() => handleCategoryClick('countries')}> {/* Clickable header */}
            <h4>COUNTRIES/REGIONS</h4>
             <span>{filters.countries?.length > 0 ? filters.countries.join(', ') : 'No Active Countries/Regions'}</span>
            <FaChevronRight className="chevron-icon"/>
          </div>
           {openCategory === 'countries' && (
             <div className="section-content nested">
                <div className="search-input-container">
                   <FaSearch />
                   <input
                     type="text"
                     placeholder="Search Countries/Regions"
                     value={searchCountries}
                     onChange={(e) => setSearchCountries(e.target.value)}
                   />
                </div>
                {/* Static list for now, would be dynamic */}  
                <label>
                  <input
                    type="checkbox"
                     checked={filters.countries?.includes('All Countries') || false}
                    onChange={() => handleCheckboxChange('countries', 'All Countries')}
                  /> All Countries
                </label>
                 <div className="nested-item">
                    Africa <FaChevronRight />
                 </div>
                  <div className="nested-item">
                     Asia <FaChevronRight />
                 </div>
                  <div className="nested-item">
                     Europe <FaChevronRight />
                 </div>
                  <div className="nested-item">
                     North America <FaChevronRight />
                 </div>
                   <div className="nested-item">
                     Oceania <FaChevronRight />
                 </div>
                   <div className="nested-item">
                     South America <FaChevronRight />
                 </div>
             </div>
           )}
        </div>

        {/* Demographics */}
        <div className={`filter-section ${openCategory === 'demographics' ? 'open' : ''}`}>
          <div className="section-header" onClick={() => handleCategoryClick('demographics')}> {/* Clickable header */}
            <h4>DEMOGRAPHICS</h4>
             <span>{filters.demographics?.length > 0 ? filters.demographics.join(', ') : 'No Active Demographics'}</span>
            <FaChevronRight className="chevron-icon"/>
          </div>
           {openCategory === 'demographics' && (
             <div className="section-content nested">
                 <div className="search-input-container">
                   <FaSearch />
                   <input
                     type="text"
                     placeholder="Search Demographics"
                     value={searchDemographics}
                     onChange={(e) => setSearchDemographics(e.target.value)}
                   />
                </div>
                {/* Static list for now, would be dynamic */}
                 <label>
                  <input
                    type="checkbox"
                    checked={filters.demographics?.includes('No Filter on Demographics') || false}
                    onChange={() => handleCheckboxChange('demographics', 'No Filter on Demographics')}
                  /> No Filter on Demographics
                </label>
                 <div className="nested-item">
                    Age <FaChevronRight />
                 </div>
                  <div className="nested-item">
                     Automated accounts <FaChevronRight />
                 </div>
                   <div className="nested-item">
                     Family Status <FaChevronRight />
                 </div>
                   <div className="nested-item">
                     Gender <FaChevronRight />
                 </div>
                   <div className="nested-item">
                     Individual Business <FaChevronRight />
                 </div>
                   <div className="nested-item">
                     Non-binary Gender <FaChevronRight />
                 </div>
                   <div className="nested-item">
                     Occupations <FaChevronRight />
                 </div>
             </div>
           )}
        </div>

      </div>
    </div>
  );
}

export default FiltersDropdown; 